import { useEffect, useState } from "react";
import api from "@/lib/api";
import { money } from "@/components/StatusBadge";
import { HandCoins, Loader2 } from "lucide-react";

// Live "you'll receive $X after the flat fee" preview for multi-pack deal owners.
// Only meaningful for the multipack scheme; render it conditionally from the parent.
export const MultipackPreview = ({ dealType, dealPrice, originalPrice, province }) => {
  const [pricing, setPricing] = useState(null);
  const [loading, setLoading] = useState(false);
  const price = parseFloat(dealPrice);

  useEffect(() => {
    if (!price || price <= 0) {
      setPricing(null);
      return;
    }
    let active = true;
    setLoading(true);
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get("/pricing/preview", {
          params: {
            deal_type: dealType || "Multi-Pack Split",
            deal_price: price,
            original_price: parseFloat(originalPrice) || 0,
            ...(province ? { province } : {}),
          },
        });
        if (active) setPricing(data);
      } catch {
        if (active) setPricing(null);
      } finally {
        if (active) setLoading(false);
      }
    }, 350);
    return () => { active = false; clearTimeout(t); };
  }, [dealType, price, originalPrice, province]);

  if (!price || price <= 0) return null;

  return (
    <div data-testid="multipack-owner-preview" className="mt-2 rounded-lg border border-blue-200 bg-blue-50 p-3 text-sm">
      <div className="flex items-center gap-1.5 font-semibold text-blue-900">
        <HandCoins className="h-4 w-4" />
        {loading || !pricing ? (
          <span className="inline-flex items-center gap-1.5 text-blue-800"><Loader2 className="h-3.5 w-3.5 animate-spin" /> Calculating…</span>
        ) : (
          <span data-testid="owner-receives-amount">You'll receive {money(pricing.owner_payout)}</span>
        )}
      </div>
      {pricing && !loading && (
        <p className="mt-1 text-[12px] leading-relaxed text-blue-800">
          Partner pays <b>{money(pricing.total_partner_pays)}</b> (their {money(pricing.partner_share)} share + tax + a {money(pricing.flat_fee)} flat fee + card processing).
          A <b>{money(pricing.owner_flat_fee)}</b> flat fee is deducted from your payout, so you net <b>{money(pricing.owner_payout)}</b>.
        </p>
      )}
    </div>
  );
};

export default MultipackPreview;
